import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  basic: any;
  private REST_API_SERVER = environment.creditorAPIEndpoint;
  private fileScanAPIEndpoint = environment.fileUploadScanAPIEndpoint;
  public ss = [];
  userId: string = '';
  httpOptions: any;
  public userProfile: any = {};
  public isLoginInProgress : boolean = false;
  public creditorUserId : any;
  public adjudicationId : any;
  creditorId: any;
  constructor(private httpClient: HttpClient) { }

  // tslint:disable-next-line:typedef
  sendGetRequest() {
    return this.httpClient.get(this.REST_API_SERVER);
  }
  // tslint:disable-next-line:typedef
  postRequest(param: string, data) {
    let url = this.REST_API_SERVER + '/' + param;
    data = encodeURIComponent(JSON.stringify(data));
    return this.httpClient.post(url,'"' + data + '"', {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  getRequest(param: string) {
    let url = this.REST_API_SERVER + '/' + param;
    return this.httpClient.get(url);
  }
  getRequestwithObject(param: string, params?:HttpParams) {
    let url = this.REST_API_SERVER + '/' + param;
    const options = Object.assign({}, this.httpOptions);
    if (params != null) {
      options.params = params;
    }
    return this.httpClient.get(url,options);
  }

  getUploadedFileContent(param: any) {
    let url = this.REST_API_SERVER + '/' + param;
    return this.httpClient.get(url);
  }

  getUserRole(param: string) {
    let url = this.REST_API_SERVER + '/' + param;
    return this.httpClient.get(url);
  }

  getRequestText(param: string) {
    let url = this.REST_API_SERVER + '/' + param;
    return this.httpClient.get(url, { responseType: 'text' });
  }

  public SetCreditorUserId(creditorUserId)
  { 
      this.creditorUserId = creditorUserId;
  }
  public SetAdjudicationId(adjudicationId)
  { 
      this.adjudicationId = adjudicationId;
  }
  public SetCreditorId(adjudicationId)
  { 
      this.creditorId = adjudicationId;
  }

  public emptyCreditorUserId()
  {
  this.creditorUserId=null;
  }
  public emptyAdjudicationId()
  {
  this.adjudicationId=null;
  }
  public emptyCreditorId()
  {
  this.creditorId=null;
  }

  // For File Upload Requests..
  public fileUploadRequest(param: string, data) {
    let url = this.REST_API_SERVER + '/' + param;

    return this.httpClient.post(url, data, { responseType: 'text' });
  }

  // For File Scan Requests..
  public fileScanRequest(param: string, data) {
    let url = this.fileScanAPIEndpoint + '/' + param;

    return this.httpClient.post(url, data);
  }

  // For Download File Requests..
  public downloadFileRequest(param: string) {
    const apiUrl = this.REST_API_SERVER + '/' + param;

    return this.httpClient.get(apiUrl, { responseType: 'blob' });
  }
  // For Http Delete Requests..
  public deleteRequest(param: string, params?: HttpParams) {
    const apiUrl = this.REST_API_SERVER + '/' + param;
    const options = Object.assign({}, this.httpOptions);
    if (params != null) {
      options.params = params;
    }
    return this.httpClient.delete(apiUrl, options);
  }
  // For Http PUT Requests..
  public putRequest(param: string, data, params?: HttpParams) {
    const apiUrl = this.REST_API_SERVER + '/' + param;
    data = encodeURIComponent(JSON.stringify(data));
    this.userId = sessionStorage.getItem('accId');
    if (this.userId) {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          UserId: this.userId,
        }),
      };
    }
    else{
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
      };
    }
    const options = Object.assign({}, this.httpOptions);
    if (params != null) {
      options.params = params;
    }
    return this.httpClient.put(apiUrl, '"' + data + '"', options);
  }
  public getUserProfile():Observable<any> {
    return this.httpClient.get(this.REST_API_SERVER + '/user/profile');
  }
}
